<template>
  <!-- <div> -->
  <el-header>
    <div style="float: right; height: 60px">
      <li
        class="el-icon-user-solid"
        style="color: white; margin-right: 10px"
      ></li>
      <el-dropdown style="vertical-align: top" @command="menuCommand">
        <span v-if="userInfo" class="el-dropdown-link" style="color: white">
          {{ userInfo.nickName
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <img class="logo" src="../../assets/login/login_logo.png" alt="" />
    <div style="display: inline-block; color: white; vertical-align: top">
      {{ userInfo.tenantName }}智慧管网管理平台
    </div>
    <el-button
      v-if="showCollapse"
      type="text"
      @click="isCollapse = !isCollapse"
      style="
        vertical-align: top;
        font-size: 26px;
        color: white;
        height: 60px;
        margin-left: 10px;
      "
      :icon="isCollapse === false ? 'el-icon-s-fold' : 'el-icon-s-unfold'"
    ></el-button>
  </el-header>
  <!-- </div> -->
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["userInfo"]),
  },
  props: {
    showCollapse: true,
  },
  methods: {
    menuCommand(command) {
      if (command == "logout") {
        localStorage.clear();
        this.$router.push("/login");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-header {
  background-color: #409eff; //#b3c0d1;
  color: #333;
  line-height: 60px;
  font-size: 26px;
  font-weight: 600;
  .logo {
    width: 40px;
    height: 40px;
    margin-top: 10px;
    margin-right: 20px;
  }
}
</style>
